import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const { ALL_AUDITS, RESPONSE_STATE, LOADER_IDENTIFIER } = STATE_IDENTIFIER;

export default {
  [ALL_AUDITS]: [],
  [RESPONSE_STATE]: IResponseState.PENDING,
  [LOADER_IDENTIFIER]: false,
};
